import { dapvApi } from 'services/providers/dapv';
import {
    PersonProjectEvent,
    GetPersonProjectEventsPayload,
    GetPersonProjectEventsResponse,
    CreatePersonProjectEventPayload,
    CreatePersonProjectEventsResponse,
    UpdatePersonProjectEventPayload,
    GetPersonProjectEventPayload,
    UpdateEventFilePayload,
    DeleteEventFilePayload,
    AddEventFilePayload
} from './event.types';
import { ApiResponse } from 'services/providers/dapv.types';

const eventApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        getPersonProjectEvents: build.mutation<GetPersonProjectEventsResponse, GetPersonProjectEventsPayload>({
            query: ({ id }: GetPersonProjectEventsPayload) => {
                return {
                    url: `/app/projects/${id}/events`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<Array<PersonProjectEvent>>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getPersonProjectEvent: build.mutation<ApiResponse<PersonProjectEvent>, GetPersonProjectEventPayload>({
            query: ({ id, eventId }: GetPersonProjectEventPayload) => {
                return {
                    url: `/app/projects/${id}/events/${eventId}`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<PersonProjectEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        createPersonProjectEvent: build.mutation<CreatePersonProjectEventsResponse, CreatePersonProjectEventPayload>({
            query: ({ id, body }: CreatePersonProjectEventPayload) => {
                return {
                    url: `/app/projects/${id}/events`,
                    method: 'POST',
                    body
                };
            },
            transformResponse: (response: ApiResponse<PersonProjectEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updatePersonProjectEvent: build.mutation<CreatePersonProjectEventsResponse, UpdatePersonProjectEventPayload>({
            query: ({ projectId, eventId, body }: UpdatePersonProjectEventPayload) => {
                return {
                    url: `/app/projects/${projectId}/events/${eventId}`,
                    method: 'PUT',
                    body
                };
            },
            transformResponse: (response: ApiResponse<PersonProjectEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getUserProjectEvents: build.mutation<GetPersonProjectEventsResponse, GetPersonProjectEventsPayload>({
            query: ({ id }: GetPersonProjectEventsPayload) => {
                return {
                    url: `/user/projects/${id}/events`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<Array<PersonProjectEvent>>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        addEventFile: build.mutation<ApiResponse<PersonProjectEvent>, AddEventFilePayload>({
            query: ({ id, eventId, body }: AddEventFilePayload) => {
                return {
                    url: `/user/projects/${id}/events/${eventId}/files`,
                    method: 'POST',
                    body
                };
            },
            transformResponse: (response: ApiResponse<PersonProjectEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        deleteEventFile: build.mutation<ApiResponse<PersonProjectEvent>, DeleteEventFilePayload>({
            query: ({ id, eventId, fileId }: DeleteEventFilePayload) => {
                return {
                    url: `/user/projects/${id}/events/${eventId}/files/${fileId}`,
                    method: 'DELETE'
                };
            },
            transformResponse: (response: ApiResponse<PersonProjectEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updateEventFile: build.mutation<ApiResponse<PersonProjectEvent>, UpdateEventFilePayload>({
            query: ({ id, eventId, fileId, body }: UpdateEventFilePayload) => {
                return {
                    url: `/user/projects/${id}/events/${eventId}/files/${fileId}`,
                    method: 'PUT',
                    body
                };
            },
            transformResponse: (response: ApiResponse<PersonProjectEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updateEventComment: build.mutation<ApiResponse<PersonProjectEvent>, { projectId: number; eventId: number; user_comment: string }>({
            query: ({ projectId, eventId, user_comment }) => ({
                url: `/user/projects/${projectId}/events/${eventId}/comment`,
                method: 'PUT',
                body: { user_comment }
            }),
            transformResponse: (response: ApiResponse<PersonProjectEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updateEventNextMeetingPreparation: build.mutation<ApiResponse<PersonProjectEvent>, { projectId: number; eventId: number; user_next_meeting_preparation: string }>({
            query: ({ projectId, eventId, user_next_meeting_preparation }) => ({
                url: `/user/projects/${projectId}/events/${eventId}/next-meeting-preparation`,
                method: 'PUT',
                body: { user_next_meeting_preparation }
            }),
            transformResponse: (response: ApiResponse<PersonProjectEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        })
    })
});

export const {
    useGetPersonProjectEventsMutation,
    useGetPersonProjectEventMutation,
    useCreatePersonProjectEventMutation,
    useUpdatePersonProjectEventMutation,
    useGetUserProjectEventsMutation,
    useAddEventFileMutation,
    useDeleteEventFileMutation,
    useUpdateEventFileMutation,
    useUpdateEventCommentMutation,
    useUpdateEventNextMeetingPreparationMutation
} = eventApi;
